import { OperatorPortalWorkPage } from "@/components/non_registrant/operator-portal-pages";
import { createFileRoute } from "@tanstack/react-router";

const validateWorkSearch = (search: Record<string, unknown>) => ({
  licenseId: (search.licenseId as string) || undefined,
});

export const Route = createFileRoute("/operator/forecasting")({
  validateSearch: validateWorkSearch,
  component: OperatorPortalWorkPage,
});
